import { render } from "./App.vue?vue&type=template&id=2681f3f5"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2681f3f5&lang=css"

import exportComponent from "C:\\Gitlab-Runner\\builds\\bssYrz32\\0\\as\\WebServerVisualization\\webclient\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__